import angular from 'angular';

let DifferentialDetailController = function ($filter, $mdDialog, $scope, $state, Toast, Differential) {
  let $ctrl = this;

  $ctrl.id = $state.params.id;
  $ctrl.differential;

  angular.extend($ctrl, {
    clearForm,
    handleSave,
    handleDelete
  });

  activate();

  function activate() {
    clearForm();

    loadResource($ctrl.id);
  }

  function clearForm(form) {
    $ctrl.differential = {};

    if (form) {
      form.$setPristine(); 
      form.$setUntouched();
    }
  }

  function handleDelete(differential, event) {
    let confirmMessage = 'differential-detail-delete-confirm-text';

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')(confirmMessage))
      .ariaLabel($filter('translate')(confirmMessage))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Differential
          .destroy(differential)
          .then(response => {
            Toast.success($filter('translate')('differential-detail-delete-success'));
            $ctrl.deleting = false;
            $state.go('differential.list')
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:' ,  err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function handleSave(form, differential) {
    if (!form.$valid) {
      Toast.error($filter('translate')('common-form-incomplete'));
      return;
    }

    save(differential);
  }

  // Local functions
  function loadResource(id){
    if (id) {
      $ctrl.uiState = 'LOADING';

      Differential.show(id)
        .then(response => {
          $ctrl.differential = response;
          $ctrl.uiState = 'COMPLETE';
        })
        .catch(err => {
          console.log('err:' ,  err);
          $ctrl.uiState = 'ERROR';
        });
    } else {
      $ctrl.uiState = 'COMPLETE';
    }
  }

  function loadDomainResources() {
    let promises = [];

    promises.push(Module.index());

    return Promise.all(promises);
  }

  function save(differential) {
    $ctrl.saving = true;

    Differential
      .save(differential)
      .then(response => {
        Toast.success($filter('translate')('differential-detail-save-success'));
        $ctrl.differential = response;
        $ctrl.saving = false;
        $state.go('differential.list');
      })
      .catch(err => {
        let defaultErrMsg = 'common-server-error';
        let fourONineMsg = 'differential-detail-409-error';
        let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
        Toast.error($filter('translate')(message));
        console.log('err:' ,  err);
        $ctrl.saving = false;
      });
  }
}

DifferentialDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Differential'];

export default DifferentialDetailController;


// WEBPACK FOOTER //
// ./client/app/components/differential/differential-detail.controller.js